import { render } from "./Freebets.vue?vue&type=template&id=b6a6e428&scoped=true"
import script from "./Freebets.vue?vue&type=script&lang=js"
export * from "./Freebets.vue?vue&type=script&lang=js"

import "./Freebets.vue?vue&type=style&index=0&id=b6a6e428&scoped=true&lang=css"
import "./Freebets.vue?vue&type=style&index=1&id=b6a6e428&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6a6e428"]])

export default __exports__